<template>
    <div>
        <pagamento-associar-comprometimentos
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
        ></pagamento-associar-comprometimentos>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import PagamentoAssociarComprometimentos from '@/app/gescon/pagamentos/PagamentoAssociarComprometimentos'

export default {
    props: {
        pagamento: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    components: {
        PagamentoAssociarComprometimentos
    }
}
</script>
